<template>
    <div class="group">
        <div class="group-header">
            <AgentAvatar
                :key="group.id"
                :size="50"
                :font-size="15"
                :userID="group.id"
                v-if="group.id"
            />
            <h2>{{ getAgentName(group.id) }}</h2>
            <div class="group-stats">
                <i class="material-icons">star</i>
                <div class="group-stats-item total">
                    <span class="key">{{ $t("chatWindow.totalCustomer") }}</span>
                    <span class="value">{{ groupStats.totalCustomers }}</span>
                </div>
                <i class="material-icons">star</i>
                <div class="group-stats-item answered">
                    <span class="key"> {{ $t("chatWindow.answered") }}</span>
                    <span class="value">{{ groupStats.answered }}</span>
                </div>
                <i class="material-icons">star</i>
                <div class="group-stats-item unanswered">
                    <span class="key">{{ $t("chatWindow.unanswered") }}</span>
                    <span class="value">{{ groupStats.unanswered }}</span>
                </div>
                <SupsisButton ghost @click="handleWatchAll">
                    {{ $t("message.watchAllLive") }}
                </SupsisButton>
            </div>
        </div>
        <div class="customers">
            <CustomerCard
                v-for="item in group.items"
                :key="item.name"
                :item="item"
                :group-id="group.id"
                :agent-name="getAgentName(group.id)"
                :selected-item-id="selectedItemId"
                @select="handleCustomerSelect"
            />
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import AgentAvatar from "../../common/AgentAvatar.vue";
import SupsisButton from "../../../views/Pages/Settings/components/SupsisButton.vue";
import CustomerCard from "./CustomerCard.vue";

export default Vue.extend({
    name: "ChatGroup",
    components: {
        AgentAvatar,
        SupsisButton,
        CustomerCard,
    },
    props: {
        group: {
            type: Object,
            required: true,
        },
        selectedItemId: {
            type: String,
            required: true,
        },
        users: {
            type: Object,
            required: true,
        },
    },
    computed: {
        groupStats() {
            return {
                totalCustomers: this.group.items.length,
                answered: this.group.items.filter((item) => item.answerStatus === "answered").length,
                unanswered: this.group.items.filter((item) => item.answerStatus !== "answered").length,
                autoAssignLimit: this.users[this.group.id]?.autoAssignLimit || 0,
            };
        },
    },
    methods: {
        getAgentName(agentId) {
            if (agentId === "chatbot") return "Chatbot";
            if (agentId === "unassign") return "Sahipsiz";
            return this.users[agentId]?.name || "-";
        },
        handleWatchAll() {
            this.$emit("watch-all", this.group.id);
        },
        handleCustomerSelect(index) {
            this.$emit("select-customer", index);
        },
    },
});
</script>

<style scoped lang="scss">
.group {
    margin-bottom: 20px;
    border-bottom: 2px solid var(--color-border-default);

    .group-header {
        padding: 5px;
        margin-bottom: 5px;
        display: flex;
        gap: 10px;
        align-items: baseline;
        justify-content: flex-start;
        align-items: center;

        h2 {
            font-size: 1.5rem;
            margin-bottom: 10px;
        }

        .group-stats {
            display: flex;
            gap: 5px;
            padding: 5px;
            border: 1px solid var(--color-border-default);
            box-shadow: 0 0 10px 0 rgb(0 0 0 / 10%);
            align-items: center;
            line-height: 30px;

            .group-stats-item {
                display: flex;
                gap: 5px;

                &.total {
                    .key {
                        color: var(--color-text-info-default);
                    }
                }

                &.answered {
                    .key {
                        color: var(--color-text-success-default);
                    }
                }

                &.unanswered {
                    .key {
                        color: var(--color-text-warning-default);
                    }
                }

                .key {
                    font-weight: bold;
                }

                .value {
                    font-size: 14px;
                    font-weight: bold;
                    color: #666;
                }
            }
        }
    }

    .customers {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
    }
}
</style>
